@if (!menuService.isHidden) {
  <aside
    [ngClass]="menuService.showSideBar ? 'w-[280px]' : 'w-20'"
    class="hidden h-full flex-col overflow-hidden border-r bg-gray-50 transition-all duration-300 md:flex">
    <app-menu-content class="flex min-h-0 flex-1 flex-col" [expanded]="menuService.showSideBar" [isMobile]="false" />
  </aside>
}
